<template>
  <div
    v-if="!close"
    class="pegi-warning"
  >
    <img
      src="/icons/PEGI_18.svg"
      alt="Pegi 18"
    />
    <p class="text">
      Ce contenu est déconseillé au moins de 18 ans.
      <br />Souhaitez-vous quand même y accéder ?
    </p>
    <div class="buttons">
      <div
        class="ok button"
        @click="closeWarning"
      >
        Accepter
      </div>
      <div
        class="return button"
        @click="$router.go(-1)"
      >
        Retour
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const cookie = useCookie<boolean>('close_warning')
const close = ref(cookie.value)

const closeWarning = () => {
  track('cta', {
    cta_name: 'Je suis majeur',
  })
  cookie.value = true
  close.value = true
}
</script>

<style lang="scss" scoped>
.pegi-warning {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: rgba(#1c1c1c, 0.9);

  img {
    width: 8.95rem;
    height: 10rem;
    margin-bottom: 4rem;
  }

  .text {
    margin-bottom: 2rem;
    color: $white;
    line-height: 1.7rem;
    text-align: center;
  }

  .buttons {
    display: inline-flex;

    .button {
      padding: 0 2rem;
      color: $white;
      font-size: 1.5rem;
      font-weight: 500;
      line-height: 4.6rem;
      cursor: pointer;
    }

    .ok {
      margin-right: 1.5rem;
      background: $blue;
    }

    .return {
      border: 1px solid $white;
    }
  }
}
</style>
